import styled from 'styled-components';

const CookiePolicyButton = styled.button`
  height: 44px;
  border: 1px solid #000000;
  border-radius: 5px;
  background-color: #000000;
  text-transform: uppercase;
  display: inline-block;
  color: #ffffff;
  font-family: 'Avenir', 'Arial', sans-serif;
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 1px;
  line-height: 20px;
  ${({ isDesktop }) => (isDesktop ? 'width: 140px;' : 'width:300px; margin: 20px 0;')}
`;

export default CookiePolicyButton;
